import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import type { FinanceOptionType } from "../../../../common-deprecated/types/CommonTypes";
import type { CarConfigSettingsType } from "../redux/slices/CarConfigSettingsSlice";

export const fetchIntegratedTradein = (
    carConfigSettings: CarConfigSettingsType,
    commonSettings: CommonSettingsType,
): boolean => !!commonSettings.query.showTradeIn || carConfigSettings.enableIntegratedTradeIn;

export const showIntegratedTradeIn = (
    carConfigSettings: CarConfigSettingsType,
    commonSettings: CommonSettingsType,
    financeOption: FinanceOptionType,
    financeProductName: string | undefined,
): boolean => {
    const isTradeInEnabled = !!commonSettings.query.showTradeIn || carConfigSettings.enableIntegratedTradeIn;
    const isAllowedFinanceProduct =
        isAllowedFinanceProductForTradeIn(carConfigSettings?.disableTradeInForFinanceProducts, financeProductName) &&
        financeOption === "monthly";
    const isCash = financeOption === "cash";

    return isTradeInEnabled && (isAllowedFinanceProduct || isCash);
};

export const isAllowedFinanceProductForTradeIn = (
    disableTradeInForFinanceProducts: string[] | undefined,
    financeProductName: string | undefined | null,
): boolean => !disableTradeInForFinanceProducts?.includes(financeProductName || "");
